export default __webpack_public_path__ + "static/media/rakesh.c3076d6b.jpeg";